import videojs from 'video.js';
import './quality-switcher-button.js';
import QualityHandler from './quality-handler.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;
const hlsHadler = videojs.VhsHandler || videojs.HlsHandler;

// Default options for the plugin.
const defaults = {
  maxFragments: 2,
  remember_quality: true
};

/**
 * @param    {Object} [options={}]
 */
function plugin(options) {
  let options_ = videojs.mergeOptions(defaults, options);
  // In the plugin function, the value of `this` is a video.js `Player` instance.
  let player = this; // eslint-disable-line no-invalid-this
  player.quality_handler = new QualityHandler(player, options_);
  
  // for videojs-contrib-hls only
  if (hlsHadler) player.qualityLevels = () => player.quality_handler.hls_quality_levels;

  const init_button = function() {
    let control_bar = player.getChild('controlBar');
    let quality_switcher_button = control_bar.getChild('qualitySwitcherButton');
    if (!quality_switcher_button) {
      let custom_control_spacer = control_bar.getChild('customControlSpacer');
      let index = custom_control_spacer && control_bar.children_.indexOf(custom_control_spacer) + 1;
      quality_switcher_button = control_bar.addChild('qualitySwitcherButton', options, index);
    }
    if (player.quality_handler.supported) {
      quality_switcher_button.show();
    } else {
      quality_switcher_button.hide();
    }
  }

  player.one('ready', init_button);
  player.quality_handler.one('qualities_initialized', init_button);
  player.on('loadstart', function() {
    player.quality_handler.processQualities();
  });
}

// Include the version number.
// plugin.VERSION = require('../package.json').version;

// Register the plugin with video.js.
registerPlugin('qualitySwitcher', plugin);

export default plugin;
